import { Datagrid, List, TextField, ShowButton } from "react-admin";

export const BookingPurposeList = () => (
  <List sort={{ field: "name", order: "ASC" }}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="name" label="Name" />
      <TextField source="id" label="Purpose ID" />
      <ShowButton />
    </Datagrid>
  </List>
);

export default BookingPurposeList;
